import * as cryptoJS from 'crypto-js';
import jwt_decode from 'jwt-decode';

/**
 * JWT compacto (HS256): firma del cuerpo con HMAC-SHA256 usando el secreto compartido con el API.
 */
export class Security {
    constructor() {}

    /**
     * Construye el JWT del cuerpo de petición (header.payload.signature).
     */
    signPayload(datos: any, secret: string): string {
        const header = {
            alg: 'HS256',
            typ: 'JWT',
        };

        const stringifiedHeader = cryptoJS.enc.Utf8.parse(JSON.stringify(header));
        const encodedHeader = this.base64url(stringifiedHeader);

        const stringifiedData = cryptoJS.enc.Utf8.parse(JSON.stringify(datos));
        const encodedData = this.base64url(stringifiedData);

        const token = encodedHeader + '.' + encodedData;

        const signature = cryptoJS.HmacSHA256(token, secret);
        const signatureBase64 = this.base64url(signature);

        return token + '.' + signatureBase64;
    }

    /**
     * Verifica la firma del JWT (HMAC sobre header.payload exactos) y devuelve el payload decodificado.
     * No re-serializa JSON: el orden de claves u opciones de stringify no deben invalidar la firma.
     */
    verifyAndDecodePayload(jwtCompact: string, secret: string): any {
        const parts = jwtCompact.split('.');
        if (parts.length !== 3) {
            return '';
        }
        const signingInput = `${parts[0]}.${parts[1]}`;
        const expectedSig = parts[2];
        const actualSig = this.base64url(cryptoJS.HmacSHA256(signingInput, secret));
        if (actualSig !== expectedSig) {
            return '';
        }
        return jwt_decode<any>(jwtCompact);
    }

    base64url(source: cryptoJS.lib.WordArray): string {
        let encodedSource = cryptoJS.enc.Base64.stringify(source);

        encodedSource = encodedSource.replace(/=+$/, '');

        encodedSource = encodedSource.replace(/\+/g, '-');
        encodedSource = encodedSource.replace(/\//g, '_');

        return encodedSource;
    }
}
